import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  useTheme,
  alpha,
  Chip
} from "@mui/material";
import {
  Payment as PaymentIcon,
  Security as SecurityIcon,
  Receipt as ReceiptIcon,
  Speed as SpeedIcon
} from "@mui/icons-material";

const AutoPayment = () => {
  const theme = useTheme();

  const paymentFeatures = [
    {
      icon: <SecurityIcon sx={{ fontSize: 40 }} />,
      title: "Secure Processing",
      description: "Bank-level encryption for all transactions"
    },
    {
      icon: <SpeedIcon sx={{ fontSize: 40 }} />,
      title: "Instant Processing",
      description: "Payments processed immediately after job completion"
    },
    {
      icon: <ReceiptIcon sx={{ fontSize: 40 }} />,
      title: "Digital Receipts",
      description: "Automated receipts and expense tracking"
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Box sx={{ textAlign: "center", mb: 8 }}>
        <Chip 
          label="💳 Auto Payment" 
          sx={{ 
            mb: 3,
            background: alpha(theme.palette.primary.main, 0.1),
            color: theme.palette.primary.dark,
            fontWeight: 600,
            fontSize: "0.85rem"
          }}
        />
        <Typography
          variant="h2"
          sx={{
            fontWeight: 700,
            color: theme.palette.text.primary,
            mb: 3,
            fontSize: { xs: "2.5rem", md: "3rem" }
          }}
        >
          Auto Payment
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: theme.palette.text.secondary,
            maxWidth: "800px",
            mx: "auto",
            lineHeight: 1.6,
            fontSize: "1.1rem"
          }}
        >
          Hassle-free payments automatically processed after each cleaning. 
          Support for multiple payment methods with complete security and transparency.
        </Typography>
      </Box>

      {/* Add your content here following the same pattern */}
    </Container>
  );
};

export default AutoPayment;